<template>
  <div class="container">
    <div class="course">
      <div
        class="cover"
        :style="`background-image:url(${$utils.fileUrl(data.cover)})`"
      ></div>
      <div class="name">
        <h2>{{ data.name }}</h2>
        <li>{{ data.companyName }}</li>
      </div>
      <el-button type="primary" size="small" @click="player(data)"
        >播放视频</el-button
      >
    </div>
    <div class="evaluate" v-if="listData.total > 0">
      <div class="comment-list">
        <div v-for="item in listData.records" :key="item">
          <div class="list-item">
            <div class="head-img">
              <img
                :src="$utils.fileUrl(item.lessonCommentList.headImage)"
                alt=""
              />
            </div>
            <div class="name-content">
              <li>
                <span
                  class="company-name"
                  :to="`/u/${item.lessonCommentList.targetId}`"
                  v-if="item.lessonCommentList.targetType === 1"
                  >{{ item.lessonCommentList.realname }}</span
                >
                <span
                  class="company-name"
                  :to="`/company/${item.lessonCommentList.targetId}`"
                  v-if="item.lessonCommentList.targetType === 2"
                  >{{ item.lessonCommentList.companyName }}
                  {{ item.lessonCommentList.realname }}</span
                >
                <span
                  class="company-name"
                  :to="`/group/${item.lessonCommentList.targetId}`"
                  v-if="item.lessonCommentList.targetType === 3"
                  >{{ item.lessonCommentList.companyName }}
                  {{ item.lessonCommentList.realname }}</span
                >
                <span>{{
                  $utils.formatDate(
                    item.lessonCommentList.createTime,
                    "yyyy-MM-dd"
                  )
                }}</span>
              </li>
              <div>
                <p>
                  {{ item.lessonCommentList.content }}
                </p>
                <div>
                  <!-- <span>回复</span>
                  <span>|</span>
                  <span>举报</span> -->
                  <el-button
                    type="primary"
                    size="small"
                    @click="setData(item.lessonCommentList.id, 1)"
                    v-if="item.lessonCommentList.manageOpen === 0"
                    >恢复展示</el-button
                  >
                  <el-button
                    type="danger"
                    size="small"
                    @click="setData(item.lessonCommentList.id, 0)"
                    v-if="item.lessonCommentList.manageOpen === 1"
                    >禁止展示</el-button
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="reply" v-if="item.lessonCommentAnswerList.length > 0">
            <div v-for="i in item.lessonCommentAnswerList" :key="i">
              <div class="reply-item">
                <div class="reply-head-img">
                  <img :src="$utils.fileUrl(i.headImage)" alt="" />
                </div>
                <div class="reply-name-date-content">
                  <li>
                    <span class="company-name" v-if="i.targetType === 1">{{
                      i.realname
                    }}</span>
                    <span
                      class="company-name"
                      :to="`/company/${i.targetId}`"
                      v-if="i.targetType === 2"
                      >{{ i.companyName }} {{ i.realname }}</span
                    >
                    <span
                      class="company-name"
                      :to="`/group/${i.targetId}`"
                      v-if="i.targetType === 3"
                      >{{ i.companyName }} {{ i.realname }}</span
                    >
                    <span>回复</span>
                    <span
                      class="company-name"
                      :to="`/u/${i.preTargetId}`"
                      v-if="i.preTargetType === 1"
                      >{{ i.preRealname }}</span
                    >
                    <span
                      class="company-name"
                      :to="`/company/${i.preTargetId}`"
                      v-if="i.preTargetType === 2"
                      >{{ i.preCompanyName }} {{ i.preRealname }}</span
                    >
                    <span
                      class="company-name"
                      :to="`/group/${i.preTargetId}`"
                      v-if="i.preTargetType === 3"
                      >{{ i.preCompanyName }} {{ i.preRealname }}</span
                    >
                  </li>
                  <li>
                    <span>{{
                      $utils.formatDate(i.createTime, "yyyy-MM-dd")
                    }}</span>
                  </li>
                  <div class="reply_content">
                    <p>
                      <span>{{ i.content }}</span>
                      <!-- <span>回复</span>
                    <span>|</span>
                    <span>举报</span> -->
                    </p>

                    <el-button
                      type="primary"
                      size="small"
                      @click="setData(i.id, 1)"
                      v-if="i.manageOpen === 0"
                      >恢复展示</el-button
                    >
                    <el-button
                      type="danger"
                      size="small"
                      @click="setData(i.id, 0)"
                      v-if="i.manageOpen === 1"
                      >禁止展示</el-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="pagination">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :current-page="listData.current"
          :page-size="10"
          :total="listData.total"
          @current-change="getPage"
        ></el-pagination>
      </div>
    </div>
    <div v-else>
      <el-empty description="暂无评论"></el-empty>
    </div>
    <!-- 播放视频 -->
    <el-dialog
      title="视频播放"
      v-model="dialogVisible"
      width="800px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="video" v-if="dialogVisible">
        <Aliplayer :source="itemData.video"></Aliplayer>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="dialogVisible = false"
            >关闭</el-button
          >
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import Aliplayer from "./../../../components/Aliplayer";
export default {
  components: { Aliplayer },
  data() {
    return {
      data: {},
      listData: {},
      loading: false,
      dialogVisible: false,
    };
  },
  methods: {
    async getData() {
      const params = this.$route.params.id;
      this.$loading.start();
      const res = await this.$api.train.video.getEvaluateData(params);
      this.$loading.done();
      if (res.code === 10200) {
        this.data = res.data.lessonInfo;
        this.listData = res.data.commentList;
      } else {
        this.$message.error(res.msg);
      }
    },
    async getPage(page) {
      this.$loading.start();
      const id = this.$route.params.id;
      const params = {
        currentPage: page,
        pageSize: 10,
      };
      const res = await this.$api.train.video.getEvaluatePage(id, params);
      this.$loading.done();
      if (res.code === 10200) {
        this.listData = res.data;
      } else {
        this.$message.error(res.msg);
      }
    },
    setData(id, status) {
      if (!this.loading) {
        const text =
          status === 0
            ? "你确定禁止展示这条评论吗？"
            : "你确定恢复展示这条评论吗？";
        this.$confirm(text, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.submitData(id, status);
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      }
    },
    async submitData(id, status) {
      this.loading = true;
      this.$loading.start();
      const params = {
        id: id,
        manageOpen: status,
      };

      try {
        const res = await this.$api.train.video.setEvaluate(params);
        this.loading = false;
        this.$loading.done();
        if (res.code === 10200) {
          this.getPage(this.listData.current);
          this.$message.success("提交成功！");
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        this.loading = false;
        this.$loading.done();
      }
    },
    player(data) {
      if (data.video === null) {
        this.$message.warning("视频还在转码中请稍后再试");
      } else {
        this.itemData = data;
        this.dialogVisible = true;
      }
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.course {
  display: flex;
  margin-bottom: 50px;
  align-items: center;

  .cover {
    width: 180px;
    height: 100px;
    margin-right: 24px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }

  .name {
    flex: 1;
    h2 {
      font-weight: 500;
      font-size: 1.125rem;
      margin-bottom: 24px;
    }
    li {
      font-size: 0.875rem;
    }
  }
}

.evaluate {
  max-width: 1000px;
}
.comment-list {
  .list-item {
    display: flex;
    min-height: 120px;
    padding: 20px 24px;
    box-sizing: border-box;
    align-items: flex-start;
    border-bottom: 1px solid #d7d7d7;

    .head-img {
      width: 60px;
      height: 60px;
      display: flex;
      margin-right: 24px;
      img {
        width: 60px;
        height: 60px;
        border-radius: 50%;
      }
    }
    .name-content {
      flex: 1;

      li {
        height: 26px;
        margin-bottom: 8px;
        line-height: 26px;

        a {
          margin-right: 17px;
          &:hover {
          }
        }

        span {
          font-size: 0.75rem;
        }

        .company-name {
          margin-right: 10px;
          font-size: 0.875rem;
        }
      }

      div {
        display: flex;
        align-items: flex-start;

        p {
          flex: 1;
          line-height: 20px;
          font-size: 0.875rem;
        }
        div {
          margin-left: 30px;
          line-height: 20px;
          span {
            font-size: 0.875rem;

            &:nth-child(2) {
              margin: 0 4px;
            }

            &:first-child {
              &:hover {
              }
            }

            &:last-child {
              &:hover {
              }
            }

            &:not(:nth-child(2)) {
              cursor: pointer;
            }
          }
        }
      }
    }
  }
  .reply {
    padding: 15px 24px 15px 15px;
    margin: 15px 0 15px 53px;
    background-color: #fafafa;
    .reply-item {
      display: flex;
      min-height: 70px;
      margin-bottom: 15px;
      align-items: flex-start;

      .reply-head-img {
        width: 36px;
        height: 36px;
        display: flex;
        margin-right: 15px;
        img {
          width: 36px;
          height: 36px;
          border-radius: 50%;
        }
      }

      .reply-name-date-content {
        flex: 1;
        li {
          line-height: 20px;
          &:first-of-type {
            a {
              font-size: 0.875rem;
            }

            span {
              margin: 0 5px;
              font-size: 0.875rem;
            }
          }
          &:last-of-type {
            span {
              font-size: 0.75rem;
            }
          }

          .company-name {
            margin: 0 !important;
            font-size: 0.875rem;
          }
        }
        .reply_content {
          display: flex;
          align-items: flex-start;
          p {
            flex: 1;
            margin-top: 5px;
            line-height: 20px;
            font-size: 0.875rem;

            span {
              &:first-child {
                margin-right: 15px;
              }

              &:nth-child(2) {
                &:hover {
                }
              }

              &:nth-child(3) {
                margin: 0 5px;
              }

              &:nth-child(even) {
                cursor: pointer;
              }
              &:last-child {
                &:hover {
                }
              }
            }
          }
        }
      }
    }
  }

  .one-level {
    margin-top: 24px;
  }

  .reply-textarea {
    padding-left: 50px;

    textarea {
      width: 100%;
      resize: none;
      padding: 15px;
      min-height: 100px;
      box-sizing: border-box;
      border: 1px solid #f1f1f1;
      background-color: #fafafa;
    }
    li {
      margin-top: 15px;
      text-align: right;
      .el-button {
        width: 120px;
      }
    }
  }
}

.video {
  height: 500px;
}
</style>